export const light = {
  primary1: '#3289C8',
  primary2: '#003A61',
  primary3: '#9E54C0',
  primary4: '#007C8F',
  primary5: '#EA7319',
  primary6: '#84878E',
  primary7: '#DF62CA',
  primary8: '#17A1AE',
  primary9: '#796807',
  primary10: '#A99142',

  secondary1: '#91BEDE',
  secondary2: '#7F9Eb4',
  secondary3: '#C7A3DA',
  secondary4: '#7FBEC7',
  secondary5: '#F4B98C',
  secondary6: '#CED2D9',
  secondary7: '#EAB9E4',
  secondary8: '#9AD2D9',
  secondary9: '#C9C3EF',
  secondary10: '#D4C8A1'
};

export const dark = {
  primary1: '#3289C8',
  primary2: '#D8EBFE',
  primary3: '#9E54C0',
  primary4: '#007C8F',
  primary5: '#EA7319',
  primary6: '#84878E',
  primary7: '#DF62cA',
  primary8: '#1FC2C6',
  primary9: '#7968D7',
  primary10: '#A99142',

  secondary1: '#91BEDE',
  secondary2: '#709DFF',
  secondary3: '#C7A3DA',
  secondary4: '#9AD2D9',
  secondary5: '#F4B98C',
  secondary6: '#CED2D9',
  secondary7: '#EAB9F4',
  secondary8: '#A5E7E8',
  secondary9: '#C9C3EF',
  secondary10: '#DAC8A1'
};

const fullSequentialSeries = (colors: any) => {
  const series = [];
  for (let i = 1; i <= 10; i++) {
    series.push(colors[`primary${i}`], colors[`secondary${i}`]);
  }
  return series;
};


const primarySequentialSeries = (colors: any) => {
  const series = [];
  for (let i = 1; i <= 10; i++) {
    series.push(colors[`primary${i}`]);
  }
  return series;
};

const fullSeries = {
  light: fullSequentialSeries(light),
  dark: fullSequentialSeries(dark)
};

const primarySeries = {
  light: primarySequentialSeries(light),
  dark: primarySequentialSeries(dark)
};

export const series = (displaySecondaryColors: any) => displaySecondaryColors ? fullSeries : primarySeries;
